// extracted by mini-css-extract-plugin
export default {"container":"onhold_container__8Rue7"};